import { render, staticRenderFns } from "./CandidateItemUpdate.vue?vue&type=template&id=549f8da4&lang=pug"
import script from "./CandidateItemUpdate.vue?vue&type=script&lang=js"
export * from "./CandidateItemUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports